<div class="about-page-dialog" *transloco="let t;">
    <i class="material-icons about-close-icon" aria-label="Close" (click)="cancel()">clear</i>
    <div class="mat-dialog-content">
        <div class="about-page" fxLayout="row" fxLayoutAlign="start center">
            <span class="logo-area">
        <img style="height: 80px;" src="../../../../../assets/images/login-logo.png" />
      </span>
            <div class="about-content">
                <h3>{{t('about.content')}}</h3>
                <p><span class="$FONT_BOLD">{{t('about.version')}}</span> 1.0.0</p>
                <p class="copyright">&copy; {{t('about.copyright')}}</p>
            </div>
        </div>
    </div>
</div>